angular.module('app').directive('hcChart', function() {
    return {
        restrict: 'A',
        scope: {
            options: '=',
            series: '=',
        },
        link: function(scope, element, attrs) {
            var chart = Highcharts.chart(element[0], scope.options);

            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
                chart.reflow();
            }, 0);

            scope.$on('ww-resizable-event', function(event, args) {
                chart.redraw();
                chart.reflow();
            });

            scope.$watch('series', function(newValue, oldValue) {
                chart.series[0].setData(newValue[0].data);
            });
        },
    };
});
